import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import { translations } from '@/lib/translations'
import { fetchList, mediaUrl } from '@/lib/api'
import { Newspaper } from 'lucide-react'

export default function BlogPage({ language, setLanguage, theme, setTheme }) {
  const t = translations[language]
  const [posts, setPosts] = useState([])

  useEffect(() => {
    fetchList('/blog').then(setPosts).catch(() => setPosts([]))
  }, [])

  return (
    <div className="bg-background text-foreground min-h-screen">
      <Header
        language={language}
        toggleLanguage={() => setLanguage(language === 'en' ? 'am' : 'en')}
        isDarkMode={theme === 'dark'}
        toggleDarkMode={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
      />
      <main className="pt-28 pb-16 px-4">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold mb-8">{t.blog?.title || 'News & Insights'}</h1>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {posts.map((post) => (
              <Link key={post.id} to={`/blog/${post.slug}`} className="rounded-2xl overflow-hidden bg-card border border-border hover:border-primary/40 transition-all">
                <div className="h-44 bg-muted">
                  {post.featuredImage ? (
                    <img src={mediaUrl(post.featuredImage)} alt="" className="w-full h-full object-cover" />
                  ) : (
                    <div className="h-full flex items-center justify-center text-primary/30"><Newspaper /></div>
                  )}
                </div>
                <div className="p-5">
                  <p className="text-xs text-primary mb-2">{post.category}</p>
                  <h2 className="font-semibold text-lg mb-2">{post.title}</h2>
                  <p className="text-sm text-muted-foreground line-clamp-3">{post.excerpt}</p>
                </div>
              </Link>
            ))}
          </div>
          {!posts.length && <p className="text-muted-foreground">No articles published yet.</p>}
        </div>
      </main>
      <Footer language={language} />
    </div>
  )
}
